<template>
    <div class="liveTools">
        <el-dialog :visible.sync="isShow">
            <div class="tools_wrap">
                <div class="left">
                    <p class="title">电脑上开播</p>
                    <img :src="mac" alt="" class="mac">
                    <el-popover placement="top" width="460" trigger="hover" popper-class="leftPopo">
                        <div class="pop_wrap">
                            <p class="liveTitle">OBS / 摄像机开播</p>
                            <p class="desp">支持户外直播 / 桌面共享 / 白板互动 / 摄像捕获</p>
                            <div class="pop_flex">
                                <span>OBS下载：</span>
                                <el-button type="success"><a href="https://cdn-img.jingketong.cn/tools/OBS-Studio-25.0.4-Full-Installer-x64.exe" download="">Windows下载</a></el-button>
                                <el-button type="success"><a href="https://cdn-img.jingketong.cn/tools/obs-mac-25.0.6.dmg" download="">macOS下载</a></el-button>
                            </div>
                            <div class="pop_flex flex_item">
                                <span class="labelName">推流服务器(URL):</span>
                                <el-input v-model="dataInfo.fmsurl" :disabled="true"></el-input>
                                <el-button v-clipboard:copy="dataInfo.fmsurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                            <div class="pop_flex flex_item">
                                <span class="labelName">推流串流密码:</span>
                                <el-input v-model="dataInfo.streamCluster" :disabled="true"></el-input>
                                <el-button v-clipboard:copy="dataInfo.streamCluster" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                            </div>
                        </div>
                        <el-button class="btn" type="primary" slot="reference">OBS</el-button>
                    </el-popover>
                </div>
                <div class="right">
                    <i class="closeIcon el-icon-close" @click="close"></i>
                    <p class="title">手机上开播</p>
                    <img :src="iPhone" alt="" class="iphone">
                    <el-popover placement="top" width="280" trigger="hover" popper-class="rightPopo">
                        <div class="pop_wrap">
                            <p class="liveTitle">小程序开播</p>
                            <p class="desp">支持视频推流/美颜/评论查看</p>
                            <p class="codeImg"><img src="http://img.jingketong.cn/mp/jktass/mp_hdtass_1280.jpg" alt=""></p>
                        </div>
                        <el-button class="btn" type="primary" slot="reference">小程序</el-button>
                    </el-popover>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getGoVliveAdressInfo} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "liveTools",
        props:[],
        data(){
            return{
                iPhone:require('@/common/images/vliveV2/iPhone.png'),
                mac:require('@/common/images/vliveV2/mac.png'),
                isShow:false,
                dataInfo:{
                    streamname:'',
                    pushurl:'',
                    xcxqrcode:'',
                }
            }
        },
        methods:{
            open(id){
                this.isShow=true;
                this.getInfo(id)
            },
            close(){
                this.isShow=false;
            },
            //获取直播推流信息
            getInfo(id){
                this.setLoading(true);
                let param={
                    liveid:id
                };
                getGoVliveAdressInfo({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.dataInfo=data.data
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            onCopy(e) {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
                console.log(e.text)
            },
            onError(e) {
                alert('失败')
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
    }
</script>

<style lang="scss">
    .liveTools{
        .tools_wrap{
            width: 1000px;
            height: 495px;
            display: flex;
            background:rgba(255,255,255,1);
            border-radius:0 6px 6px 0;
            div{
                flex: 1;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                .title{
                    font-size: 24px;
                    color: #000;
                    padding: 40px 0 30px 0;
                }
                .btn{
                    width: 100px!important;
                    margin: 50px auto 0!important;
                }
            }
            .left{
                background:rgba(240,242,245,1);
                .mac{
                    width: 457px;
                    height: 281px;
                }
            }
            .right{
                .closeIcon{
                    font-size: 20px;
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    cursor: pointer;
                }
                .iphone{
                    width: 165px;
                    height: 281px;
                }
            }
        }
        .el-dialog .el-dialog__body{
            padding: 0;
        }
        .el-dialog .el-dialog__header {
            border-bottom: none;
            display: none;
        }
        .el-dialog {
            width: 1000px;
            position: relative;
        }
    }
    /*左边弹窗样式*/
    .leftPopo{
        .pop_wrap{
            padding: 20px;
            .liveTitle{
                color: #333;
                font-size: 16px;
            }
            .pop_flex{
                margin-top: 20px;
                a{
                    color: #fff;
                    width: 120px;
                    display: inline-block;
                }
            }
            .flex_item{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .labelName{
                    min-width: 120px;
                    display: inline-block;
                }
                .el-input{
                    width: 300px;
                }
                .el-button{
                    min-width: auto;
                    border: none;
                    color: #409EFF;
                    margin-left: 10px;
                }
                .el-button:focus, .el-button:hover{
                    background: none;
                }
                .el-input.is-disabled .el-input__inner {
                     background-color: #fff;
                     border-color: #eee;
                     color: #333;
                    cursor: not-allowed;
                }
            }
            .desp{
                margin-top: 10px;
                color: #909399;
                font-size: 14px;
            }
        }
    }
    .rightPopo{
        .pop_wrap{
            padding: 20px;
            .liveTitle{
                color: #333;
                font-size: 16px;
            }
            .desp{
                margin-top: 10px;
                color: #909399;
                font-size: 14px;
            }
            .codeImg{
                text-align: center;
                img{
                    width: 136px;
                    height: 136px;
                    margin: 18px auto 0;
                    display: inline-block;
                }
            }
        }
    }
</style>
